import styled from 'styled-components';

export const StyledSpan = styled.span`
  display: block;
`;
